import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import toast from 'react-hot-toast';
import { MenuItem, Select, Stack, Typography } from '@mui/material';
import DialogConfirmation from './DialogConfirmation';
import _ from 'lodash';
import { useLocation, useNavigate } from 'react-router-dom';

export default function FormlistDialog({ open, setOpen, metadata, updateHeaders, objectLibraries }) {
  const [option, setOption] = React.useState({ key: '', value: '' });
  const [confirmationOpen, setConfirmationOpen] = React.useState(false);
  const [formlist, setFormlist] = React.useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const handleDelete = async ({ isConfirmed }) => {
    if (!isConfirmed) {
      setConfirmationOpen(true);
    } else {
      try {
        const { index, type } = metadata;
        const value = metadata?.options?.splice(metadata?.index_options, 1);
        await updateHeaders(index, value, type);
        toast.success('Data deleted');
        handleClose();
      } catch (error) {
        handleClose();
        toast.error(error.message);
      }
    }
  };

  const handleClose = () => {
    setOpen(false);
    setConfirmationOpen(false);
    setFormlist('');
  };

  const handleSave = async () => {
    try {
      const { index } = metadata;
      const objectIndex = _.findIndex(objectLibraries, (obj) => {
        return obj.id === formlist;
      });

      if (objectIndex > -1) {
        const value = objectLibraries[objectIndex]?.attributes?.options || [];
        await updateHeaders(index, value, 'options');
        await updateHeaders(index, 'object_libraries', 'options_type');
        toast.success('Data updated, please click save button to apply the changes');
        handleClose();
      } else {
        toast.error('Index not found');
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const updateField = () => {
    setOption({ key: metadata?.item_options?.key, value: metadata?.item_options?.value });
  };

  React.useEffect(() => {
    // if (metadata.options && metadata.isExist) updateField();
    // eslint-disable-next-line
  }, [metadata]);

  return (
    <div>
      <Dialog maxWidth='md' open={open} onClose={handleClose}>
        <DialogTitle>Libraries</DialogTitle>
        <DialogContent>
          <DialogContentText>Select predefined library for your checkboxes/radios</DialogContentText>
          <Stack direction='column' spacing={1} mt={2}>
            <Typography variant='caption' sx={{ fontWeight: 600 }}>
              Library:
            </Typography>
            <Select
              variant='standard'
              labelId='formlist-select'
              id='formlist-select'
              value={formlist}
              label='Library'
              onChange={(e) => setFormlist(e.target.value)}
              placeholder='Select predefined library'
            >
              {!_.isEmpty(objectLibraries) && objectLibraries.map((lib, lib_index) => <MenuItem value={lib?.id}>{lib?.attributes?.label}</MenuItem>)}
            </Select>
            {/* {JSON.stringify(formlist)} */}
          </Stack>
        </DialogContent>

        <Stack direction='row' justifyContent='space-between' m={2}>
          <Stack>
            <Button onClick={() => window.open(`${location.pathname}/library-editor`, '_blank')}>Library editor?</Button>
          </Stack>
          <Stack direction='row'>
            <Button onClick={handleClose}>Cancel</Button>
            <Button disabled={_.isEmpty(formlist)} onClick={handleSave}>
              Save
            </Button>
          </Stack>
        </Stack>
      </Dialog>
      <DialogConfirmation
        open={confirmationOpen}
        handleClose={() => setConfirmationOpen(false)}
        title='Deletion Confirmation'
        content='Are you sure want to delete this data?'
        closeButtonText='No'
        agreeButtonText='Yes'
        handleAgree={() => handleDelete({ isConfirmed: true })}
      />
    </div>
  );
}
